const PropTypes = require('prop-types');
const React = require('react');
const PriceDisplay = require('components/shared/price_display.jsx');
const UrlHelpers = require('components/shared/url_helpers.js');
const { HashUtil } = require('@reverbdotcom/discovery-ui');

class CartItem extends React.Component {
  merchandisingThumbnail() {
    const merchandisingImages = HashUtil.getSafely(
      this.props,
      'merchandisingData.images'
    );

    if (!(merchandisingImages && merchandisingImages.length)) {
      return null;
    }

    return HashUtil.getSafely(merchandisingImages[0], '_links.thumb_small.href');
  }

  get item() {
    return this.props.item;
  }

  get thumbnail() {
    return this.merchandisingThumbnail() || this.item.thumbnail;
  }


  renderQuantity() {
    if (!this.item.quantity) { return null; }
    return <span className="mr-half">{`${this.item.quantity}x`}</span>;
  }

  renderOriginalPrice() {
    if (!this.item.originalItemPrice) { return null; }

    return (
      <strike className="mr-half muted">
        <PriceDisplay
          price={this.item.originalItemPrice}
          showCurrency={false}
        />
      </strike>
    );
  }

  renderPrice() {
    if (this.item.eligibleSale) {
      return (
        <span className="site-header__menu__item__description__discount-price">
          <PriceDisplay price={this.item.itemPrice} />
        </span>
      );
    }

    return <PriceDisplay price={this.item.itemPrice} />;
  }

  renderSaleReminder() {
    if (this.item.eligibleSale) {
      return (
        <p className="site-header__menu__item__description__sale-reminder">
          {this.item.saleReminderText}
        </p>
      );
    }
    return null;
  }

  render() {
    return (
      <div className="site-header__menu__item">
        <a
          className="site-header__menu__link"
          href={UrlHelpers.cartPath}
          onClick={this.props.trackClick}
        >
          <img
            src={this.thumbnail}
            alt={this.item.title}
            width="96"
            height="96"
          />
          <div className="site-header__menu__item__description">
            {this.renderSaleReminder()}
            <div className="site-header__menu__item__description__title">
              {this.item.title}
            </div>
            <small>
              {this.renderQuantity()}
              {this.renderOriginalPrice()}
              {this.renderPrice()}
            </small>
          </div>
        </a>
      </div>
    );
  }
}

CartItem.propTypes = {
  trackClick: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  merchandisingData: PropTypes.object,
};

module.exports = CartItem;



// WEBPACK FOOTER //
// ./javascripts/components/header/cart/cart_item.jsx